import { Box, IconButton, TextField, Typography } from "@mui/material";
import { format } from "date-fns";
import { useEffect, useReducer} from "react";
import DateRangeIcon from '@mui/icons-material/DateRange';
import DatePickerDialog from "./datePickerDialog";
import useDialogModal from "../../hooks/useDialogModal";
import useEffectOnUpdates from "../../hooks/useEffectOnUpdates";

export default function DatePickerComponent({ name, id, value, onDateSelectionDone }) {

    const [DatePicker, showDatePicker] =
        useDialogModal(DatePickerDialog);

    const [state, updateState] = useReducer((state, params) => {
        return { ...state, ...params }
    }, {
        year: '',
        month: '',
        day: '',
        yearTouched: false,
        monthTouched: false,
        dayTouched: false,
        errors: {
            year: '',
            month: '',
            day: ''
        }
    });

    const noErrors = () => {

        return state.errors.year === '' &&
        state.errors.month === '' &&
        state.errors.day === '';
    }

    useEffect(() => {

        if (value) {
            if (value instanceof Date) {
                console.error("date is instance of date")
            } else {
                updateState({
                    year: value.split('-')[0],
                    month: value.split('-')[1],
                    day: value.split('-')[2]
                });
            }
        }
    }, [value]);

    const handleDatePickerDone = (value) => {
        const dv = format(value, 'yyyy-MM-dd');
        if (dv) {
            updateState({
                year: dv.split('-')[0],
                month: dv.split('-')[1],
                day: dv.split('-')[2]
            });
        }
        //setDateValue(dv)
        //onDateSelectionDone(dv);
    };

    /**update the client */
    useEffectOnUpdates(() => {
        if (state.year && state.month && state.day
            && noErrors() )
            onDateSelectionDone(`${state.year}-${state.month}-${state.day}`);
        else
            onDateSelectionDone(null);

    }, [state.year, state.month, state.day]);

    const handleYearChange = (event) => {
        const value = event.target.value;
        let error = '';
        if (!(value > 1900 && value <= new Date().getFullYear())) {
            error = 'Invalid Year'
        }
        updateState({ year: value, errors: { ...state.errors, year: error } });

    }

    const handleMonthChange = (event) => {
        const value = event.target.value;
        let error = '';
        if (!(value >= 1 && value <= 12)) {
            error = 'Invalid month'
        }
        updateState({ month: value, errors: { ...state.errors,month: error } });
    }

    const handleDayChange = (event) => {
        const value = event.target.value;
        let error = '';
        if (!(value >= 1 && value <= 31)) {
            error = 'Invalid day'
        }
        updateState({ day: value, errors: { ...state.errors,day: error } });
    }
    return (

        <Box display={"flex"} alignItems="end">
            <TextField
                name={`${name}-year`}
                id={`${id}-year`}
                value={state.year}
                onChange={handleYearChange}
                variant="standard"
                error={
                    state.yearTouched && Boolean(state.errors.year)
                }
                onClick={() => updateState({ yearTouched: true })}
                //onBlur={() => updateState({ yearTouched: false })}
                helperText={state.yearTouched && state.errors.year}
                label="Year"
                type={"number"}
            />
            <Typography sx={{ pl: 2, pr: 2 }}>/</Typography>
            <TextField
                name={`${name}-month`}
                id={`${id}-month`}
                value={state.month}
                onChange={handleMonthChange}
                variant="standard"
                error={
                    state.monthTouched && Boolean(state.errors.month)
                }
                onClick={() => updateState({ monthTouched: true })}
                //onBlur={() => updateState({ monthTouched: false })}
                helperText={state.monthTouched && state.errors.month}
                label="Month"
                type={"number"}
            />
            <Typography sx={{ pl: 2, pr: 2 }}>/</Typography>
            <TextField
                name={`${name}-day`}
                id={`${id}-day`}
                value={state.day}
                onChange={handleDayChange}
                variant="standard"
                error={
                    state.dayTouched && Boolean(state.errors.day)
                }
                onClick={() => updateState({ dayTouched: true })}
                //onBlur={() => updateState({ dayTouched: false })}
                helperText={state.dayTouched && state.errors.day}
                label="Day"
                type={"number"}
            />

            <IconButton onClick={showDatePicker}>
                <DateRangeIcon color="primary" />
            </IconButton>
            <DatePicker date={value} onDone={handleDatePickerDone} />
        </Box>

    )

}